"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmazonTranslateLanguages = void 0;
var AmazonTranslateLanguages;
(function (AmazonTranslateLanguages) {
    AmazonTranslateLanguages["Afrikaans"] = "af";
    AmazonTranslateLanguages["Albanian"] = "sq";
    AmazonTranslateLanguages["Amharic"] = "am";
    AmazonTranslateLanguages["Arabic"] = "ar";
    AmazonTranslateLanguages["Azerbaijani"] = "az";
    AmazonTranslateLanguages["Bengali"] = "bn";
    AmazonTranslateLanguages["Bosnian"] = "bs";
    AmazonTranslateLanguages["Bulgarian"] = "bg";
    AmazonTranslateLanguages["Chinese"] = "zh";
    AmazonTranslateLanguages["Croatian"] = "hr";
    AmazonTranslateLanguages["Czech"] = "cs";
    AmazonTranslateLanguages["Danish"] = "da";
    AmazonTranslateLanguages["Dutch"] = "nl";
    AmazonTranslateLanguages["English"] = "en";
    AmazonTranslateLanguages["Estonian"] = "et";
    AmazonTranslateLanguages["Finnish"] = "fi";
    AmazonTranslateLanguages["French"] = "fr";
    AmazonTranslateLanguages["Georgian"] = "ka";
    AmazonTranslateLanguages["German"] = "de";
    AmazonTranslateLanguages["Greek"] = "el";
    AmazonTranslateLanguages["Hausa"] = "ha";
    AmazonTranslateLanguages["Hebrew"] = "he";
    AmazonTranslateLanguages["Herero"] = "hz";
    AmazonTranslateLanguages["Hindi"] = "hi";
    AmazonTranslateLanguages["Hungarian"] = "hu";
    AmazonTranslateLanguages["Indonesian"] = "id";
    AmazonTranslateLanguages["Italian"] = "it";
    AmazonTranslateLanguages["Japanese"] = "ja";
    AmazonTranslateLanguages["Korean"] = "ko";
    AmazonTranslateLanguages["Latvian"] = "lv";
    AmazonTranslateLanguages["Malay"] = "ms";
    AmazonTranslateLanguages["Norwegian"] = "no";
    AmazonTranslateLanguages["Persian"] = "fa";
    AmazonTranslateLanguages["Polish"] = "pl";
    AmazonTranslateLanguages["Portuguese"] = "pt";
    AmazonTranslateLanguages["Romanian"] = "ro";
    AmazonTranslateLanguages["Russian"] = "ru";
    AmazonTranslateLanguages["Serbian"] = "sr";
    AmazonTranslateLanguages["Slovak"] = "sk";
    AmazonTranslateLanguages["Slovenian"] = "sl";
    AmazonTranslateLanguages["Somali"] = "so";
    AmazonTranslateLanguages["Spanish"] = "es";
    AmazonTranslateLanguages["Swahili"] = "sw";
    AmazonTranslateLanguages["Swedish"] = "sv";
    AmazonTranslateLanguages["Tagalog"] = "tl";
    AmazonTranslateLanguages["Tamil"] = "ta";
    AmazonTranslateLanguages["Thai"] = "th";
    AmazonTranslateLanguages["Turkish"] = "tr";
    AmazonTranslateLanguages["Ukrainian"] = "uk";
    AmazonTranslateLanguages["Urdu"] = "ur";
    AmazonTranslateLanguages["Vietnamese"] = "vi";
})(AmazonTranslateLanguages || (exports.AmazonTranslateLanguages = AmazonTranslateLanguages = {}));
